module.exports = __webpack_public_path__ + "static/media/Signup.168b74ea.png";